import { useState, useEffect, useRef } from 'react';
import { message, Modal } from 'antd';
import eventBus from '@/utils/eventBus'
import './index.scss'
import login from '@/utils/login'
import user from '@/utils/user'
import { useNavigate } from 'react-router-dom';

const AuthGuard = () => {
  const navigate = useNavigate()
  const isModalShow = useRef(false);

  const [authExpiredVisible, setAuthExpiredVisible] = useState(false);
  const [authChangedVisible, setAuthChangedVisible] = useState(false);
  const [noAuthVisible, setNoAuthVisible] = useState(false);

  const handleAuthExpired = () => {
    if (isModalShow.current) return;
    isModalShow.current = true;
    setAuthExpiredVisible(true);
  };

  const handleAuthChanged = () => {
    if (isModalShow.current) return;
    isModalShow.current = true;
    setAuthChangedVisible(true);
  }

  const handleRequestFailed = ({
    status,
    error,
    errorDescription,
    error_description
  }: {
    status: number
    error: string | undefined,
    errorDescription: string | undefined,
    error_description: string | undefined
  }) => {
    if (isModalShow.current) return;
    isModalShow.current = true;

    if (error === 'login_permission.not_config') {
      setNoAuthVisible(true);
    } else {
      isModalShow.current = false;
      message.error(errorDescription || error_description || '请求失败');
    }
  }

  const handleRequest404 = () => {
    message.error('请求错误');
  }

  // 关闭所有弹窗
  const closeAllDialogs = () => {
    isModalShow.current = false;
    setAuthExpiredVisible(false);
    setAuthChangedVisible(false);
    setNoAuthVisible(false);
  };

  // 确认重新登录
  const confirmReLogin = () => {
    isModalShow.current = false;
    setAuthExpiredVisible(false);
    setAuthChangedVisible(false);
    setNoAuthVisible(false);
    user.remove()
    login.logout()
    navigate('/login')
  }

  useEffect(() => {
    eventBus.on('auth:expired', handleAuthExpired);
    eventBus.on('auth:changed', handleAuthChanged);
    eventBus.on('request:error', handleRequestFailed);
    eventBus.on('request:404', handleRequest404);

    return () => {
      eventBus.off('auth:expired', handleAuthExpired);
      eventBus.off('auth:changed', handleAuthChanged);
      eventBus.off('request:error', handleRequestFailed);
      eventBus.off('request:404', handleRequest404);
    };
  }, []);

  return <>
    <Modal
      className="authExpired-warning"
      centered
      title="登录已失效"
      okText="去登录"
      open={authExpiredVisible}
      onOk={confirmReLogin}
      onCancel={closeAllDialogs}
    >
      <div>您的登录状态已过期，请重新登录</div>
    </Modal>
    <Modal
      className="authExpired-warning"
      centered
      title="权限已改动"
      okText="去登录"
      open={authChangedVisible}
      onOk={confirmReLogin}
      onCancel={closeAllDialogs}
    >
      <div>您的权限已改动，请重新登录</div>
    </Modal>
    <Modal
      className="authExpired-warning"
      centered
      title="账号提示"
      okText="确定"
      open={noAuthVisible}
      onOk={confirmReLogin}
      onCancel={closeAllDialogs}
    >
      <div>当前角色或账号没有登录权限，请联系管理员确认并开通权限信息</div>
    </Modal>
  </>;
};

export default AuthGuard;